import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Toast from 'react-bootstrap/Toast';

import 'react-table-v6/react-table.css';
import { userChangeAction, tabChangeAction } from '../../stores/actions/userData';
import { connect } from 'react-redux';
import modelListService from './modelListService';
import PropTypes from 'prop-types';
import { Config } from '../../shared/config';
import { fetchCurrentUserDetails } from '../../Auth.service';
import TokenManagerService from '../../services/TokenManagerService';
import './modelListStyle.scss';

import SubHeader from '../Layout/SubHeader';
import { isParametersOrVariablesUpdatedAction } from './../../stores/actions/modelInputReader';
import UserList from './Admin/components/UserList';
import CustomerList from './Admin/components/CustomerList';
import EtlJobList from './Admin/components/EtlJobList';
import EtlExportView from './Admin/components/EtlExportView';
import RenamePopup from './RenamePopup';
import ETLContainer from './ETL';
import AnalyticsExplores from './Analytics/AnalyticsExplores';
import TabDashboards from './Actuals/TabDashboards';
import * as R from 'ramda';
import './Actuals/TabPatientRegistry/tabPatientRegistry.scss';
import TabARManagement from './Actuals/TabARManagement';
import TabDrugAccess from './Actuals/TabDrugAccess';
const safeJsonParse = R.tryCatch(JSON.parse, R.always(null));

class ModelLanding extends Component {
    constructor(props) {
        super(props);
        let fomUser = localStorage.getItem('FOM_user');
        let fomCustomer = localStorage.getItem('FOM_recent_customer');
        const session = safeJsonParse(fomUser);
        const sessionCustomer = safeJsonParse(fomCustomer);
        this.state = {
            pages: null,
            customerId: null,
            loading: false,
            showPagination: false,
            showCustomerList: false,
            searchCustomerText: '',
            customerSelected: false,
            selectedCustomerId: session && session.userdata.details.customerId,
            userdata: session && session.userdata.details,
            customerList: [],
            modelData: [],
            showToast: false,
            selectedModelData: null,
            showRename: false,
            currentTab: 'actuals',
            currentAdminTab: 'admin_user-list',
            modelClosed: false,
            updatedCustomermodelId: null,
            ingestFileLocation: '',
            currentAnalyticsTab: 'analytics_dashboard-list',
            showARModal: true,
            api: {
                response: {
                    status: '',
                    message: '',
                },
            },
            masterModel: {
                modelId: '',
                versionId: '',
                customerId: '',
            },
            customerName: sessionCustomer && sessionCustomer.customerName,
        };
        this.setCustomerWrapperRef = this.setCustomerWrapperRef.bind(this);
        this.modelListService = new modelListService();
    }

    /**
     * Toggle toast
     */
    toggleToast = () => {
        const { showToast } = this.state;
        this.setState({
            showToast: !showToast,
        });
        setTimeout(() => {
            this.setState({
                showToast: false,
            });
        }, 4000);
    };

    /**
     * Toggle toast
     */
    setShowARModal = (r) => {
        this.setState({
            showARModal: r,
        });
    };

    /**
     * Ui render function
     */
    render() {
        const {
            currentAdminTab,
            ingestFileLocation,
            userdata,
            showRename,
            showToast,
            api,
            currentTab,
            showARModal,
            customerName,
        } = this.state;

        let selectedCustomerId = this.state.selectedCustomerId;
        let selectedCusName = customerName;

        //Set model empty table message
        if (this.props.userData && this.props.userData.modelPayload) {
            if (this.props.userData.modelPayload.customerId) {
                selectedCustomerId = this.props.userData.modelPayload.customerId;
                selectedCusName = this.props.userData.modelPayload.customerName;
            }
        }

        //Set active tab, which to remind where we left off
        let activeTab = currentTab;
        let activeAdminTab = currentAdminTab;
        if (this.props.getCurrentTab && this.props.getCurrentTab.tabPayload) {
            let tabName = this.props.getCurrentTab.tabPayload;
            if (tabName.indexOf('_') > -1) {
                var tabData = tabName.split('_');
                activeTab = tabData[0];
                if (activeTab === 'admin') {
                    activeAdminTab = tabName;
                }
            } else {
                activeTab = this.props.getCurrentTab.tabPayload;
            }
        }

        const isUserAdmin = userdata?.role === Config.user.role.admin;
        const isARManagement = userdata?.role != Config.user.role.customer;

        console.log(' selectedCustomerId ', selectedCustomerId);

        /**
         * Ui elements return
         */
        return (
            <>
                {showToast && api && api.response ? (
                    <Row>
                        <Col md={12} className="pt-2">
                            <Toast className="toast-container" show={showToast} onClose={this.toggleToast}>
                                <Toast.Header
                                    className={` ${api && api.response.status !== 'Failure' ? 'success' : 'error'}`}
                                >
                                    <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                                    <strong className="mr-auto">{api.response.status}</strong>
                                </Toast.Header>
                                <Toast.Body>{api.response.message}</Toast.Body>
                            </Toast>
                        </Col>
                    </Row>
                ) : null}

                {showRename ? (
                    <div>
                        <RenamePopup />
                    </div>
                ) : null}
                <>
                    {userdata ? (
                        <>
                            <Row noGutters>
                                <Col xs={12} md={4}>
                                    <SubHeader />
                                </Col>
                            </Row>
                            <Row className="tab-box-container">
                                <Col md={12}>
                                    <Tabs
                                        defaultActiveKey={activeTab}
                                        onSelect={this.handleTabChange}
                                        className="pt-2 pl-3 bg-white"
                                    >
                                        <Tab eventKey="etl" className="file-upload-container" title="File Upload">
                                            <ETLContainer
                                                modalHelp={{}}
                                                mainActiveTab={activeTab}
                                                ingestFileLocation={ingestFileLocation}
                                                customerId={selectedCustomerId}
                                            />
                                        </Tab>
                                        <Tab
                                            eventKey="analytics"
                                            className="analytics-explores-container"
                                            title="Report Builder"
                                        >
                                            <AnalyticsExplores customerId={selectedCustomerId} />
                                        </Tab>
                                        <Tab
                                            eventKey="actuals"
                                            className="actuals-dashboards-container"
                                            title="Dashboards"
                                        >
                                            <TabDashboards customerId={selectedCustomerId} />
                                        </Tab>
                                        {isARManagement && (
                                            <Tab
                                                eventKey="AR"
                                                className="actuals-ar-management-container"
                                                title="AR Management"
                                            >
                                                <TabARManagement
                                                    customerId={selectedCustomerId}
                                                    userFullname={userdata.fullName}
                                                    setShowARModal={this.setShowARModal}
                                                    showARModal={showARModal}
                                                />
                                            </Tab>
                                        )}

                                        {isUserAdmin && (
                                            <Tab
                                                eventKey="DrugAccess"
                                                className="actuals-drug-access-container"
                                                title="Drug Access"
                                            >
                                                <TabDrugAccess
                                                    customerId={selectedCustomerId}
                                                    customerName={selectedCusName}
                                                />
                                            </Tab>
                                        )}

                                        {/* Separate Admin role check due to Tab having to be a child component under Tabs component */}
                                        {isUserAdmin && (
                                            <Tab eventKey="admin" className="bg-white min-height-tab" title="Admin">
                                                <Row>
                                                    <Col md={12}>
                                                        <div className="tab-container">
                                                            <Tabs
                                                                defaultActiveKey={activeAdminTab}
                                                                onSelect={this.handleTabChange}
                                                                className="pt-2 pl-3 bg-white"
                                                            >
                                                                <Tab
                                                                    eventKey="admin_user-list"
                                                                    className="bg-white"
                                                                    title="Users"
                                                                >
                                                                    <UserList />
                                                                </Tab>
                                                                <Tab
                                                                    eventKey="admin_customer-list"
                                                                    className="bg-white"
                                                                    title="Customers"
                                                                >
                                                                    <CustomerList />
                                                                </Tab>
                                                                <Tab
                                                                    eventKey="admin_etljob-list"
                                                                    className="bg-white"
                                                                    title="Jobs"
                                                                >
                                                                    <div className="etl-view-container">
                                                                        <EtlJobList
                                                                            customerId={selectedCustomerId}
                                                                            mode={'ADMIN'}
                                                                        />
                                                                    </div>
                                                                </Tab>
                                                                <Tab
                                                                    eventKey="admin_etlexports"
                                                                    className="bg-white"
                                                                    title="Exports"
                                                                >
                                                                    <EtlExportView customerId={selectedCustomerId} />
                                                                </Tab>
                                                            </Tabs>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Tab>
                                        )}
                                    </Tabs>
                                </Col>
                            </Row>
                        </>
                    ) : null}
                </>
            </>
        );
    }

    /**
     * Handle tab change event
     * @param {*} tabName tab name
     */
    handleTabChange = (tabName) => {
        this.props.setCurrentTab(tabName);
    };

    /**
     * Set customer wrap reference
     * @param {*} node node
     */
    setCustomerWrapperRef(node) {
        this.customerWrapperRef = node;
    }

    componentDidMount() {
        // Role/customerId are read from localStorage in the constructor for
        // instant first render, but localStorage is client-writable (devtools,
        // or a response-rewriting proxy) and must never be trusted for
        // access-control decisions. Re-verify against the server on mount and
        // overwrite state with the authoritative value before any role-gated
        // tab (AR Management / Drug Access / Admin) can be relied on.
        const accessToken = TokenManagerService.getAccessToken();
        if (!accessToken) return;
        fetchCurrentUserDetails(accessToken)
            .then((details) => {
                if (details && details.role) {
                    this.setState({
                        userdata: details,
                        selectedCustomerId: details.customerId,
                    });
                }
            })
            .catch(() => {
                // Live check failed (e.g. transient network error); the axios
                // response interceptor in App.js already handles 401s via
                // silent refresh or logout, so no extra handling is needed here.
            });
    }

    /**
     * Component will mount
     */
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
}

//Get value from redux store
const MapStateToProps = (state) => {
    return {
        userData: state.userChangeAction,
        modelStatus: state.modalOnCloseAction,
        getCurrentTab: state.getTabChangeAction,
    };
};

//Set vaues to redux store
const MapDispatchToProps = (dispatch) => {
    return {
        updateUser: (params) => dispatch(userChangeAction(params)),
        setCurrentTab: (params) => dispatch(tabChangeAction(params)),
        setVariablesUpdated: (params) => dispatch(isParametersOrVariablesUpdatedAction(params)),
    };
};

ModelLanding.propTypes = {
    modelStatus: PropTypes.object,
    updateModal: PropTypes.func,
    history: PropTypes.object.isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }),
    userData: PropTypes.object,
    setVariablesUpdated: PropTypes.func,
    updateUser: PropTypes.func,
    setCurrentTab: PropTypes.func,
    getCurrentTab: PropTypes.object,
    customerId: PropTypes.string,
};

export default connect(MapStateToProps, MapDispatchToProps)(withRouter(ModelLanding));
